import { render, staticRenderFns } from "./huehome.vue?vue&type=template&id=73dae2aa&scoped=true&"
import script from "./huehome.vue?vue&type=script&lang=js&"
export * from "./huehome.vue?vue&type=script&lang=js&"
import style0 from "./huehome.vue?vue&type=style&index=0&id=73dae2aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dae2aa",
  null
  
)

export default component.exports